import catheter from '@/sui/data/sheets/edit/catheter'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import fields from '@/sui/data/sheets/edit/fields'
import tools from '@/sui/data/sheets/edit/tools'
import notes from '@/sui/data/sheets/edit/notes/reaBactADI'
import go from '@/gojs/go'

const catheterType = tools.cfg.list(
  fields.catheterType, 'Type de cathéter', go.fields2019.reaBactCatheterType,
  { sel: catheter.select.kt }
)

export default {
  '2019': {
    titles: [
      {
        text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
        start: 'uf'
      },
      {
        text: `DONNÉES RELATIVES À L'EXPOSITION AUX CATHÉTERS CENTRAUX`,
        start: 'catheters'
      },
      {
        text: 'DONNÉES RELATIVES À LA BACTÉRIÉMIE ASSOCIÉE AUX SOINS',
        start: 'bacteremias'
      },
      {
        text: 'DEVENIR DU PATIENT',
        start: 'dead'
      }
    ],

    fields: [
      patient.sheetNumber.v1,
      patient.ufs.reaBactADI,
      patient.unitType.v1.ro,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.patientOrigin.v1,
      patient.trauma,
      patient.diagnosis,
      patient.immuno,
      patient.antibio,
      patient.mixManagment,
      patient.igsII,
      patient.pimII.mix,
      patient.cribII.mix,
      patient.otherSeverity,
      patient.otherSeverityScore,
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      {
        field: fields.catheterArray,
        type: 'array',
        config: {
          title: 'CATHETER CENTRAL N°',
          fields: [
            catheter.present,
            catheterType,
            tools.select(catheter.insertionDate, catheter.select.kt),
            tools.select(catheter.removed, catheter.select.kt),
            tools.select(catheter.removalDate, catheter.select.ktr)
          ]
        }
      },
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v1.array
        }
      },

      patient.dead,
      patient.deathDate,
      patient.exitDate
    ],

    buildNotes: function (result, sheet) {
      return notes.build2019(result, sheet)
    }
  }
}
